function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import * as S from './styled';
const HeadingStyle = styled.h1`
  ${S.HeadingBase}
  ${props => S[props.variant]};
  ${props => S[props.color]};
  ${props => S[props.textAlign]};
  ${props => S[props.textTransform]};
`;

const Heading = ({
  element,
  ...props
}) => /*#__PURE__*/React.createElement(HeadingStyle, _extends({
  as: element
}, props));

Heading.defaultProps = {
  children: null,
  color: 'black',
  textAlign: 'left',
  textTransform: 'none'
};
Heading.propTypes = {
  children: PropTypes.node,
  element: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']).isRequired,
  variant: PropTypes.oneOf(['one', 'two', 'three', 'four', 'five', 'six', 'brand', 'tag']).isRequired,
  color: PropTypes.oneOf(['white', 'black']),
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  textTransform: PropTypes.oneOf(['none', 'lowercase'])
};
export default Heading;